// src/components/more/More.js
import React from 'react';
import { Camera, Video, ChevronRight, LogOut, User, Baby, School, PencilRuler, MessageCircle, Newspaper, Activity } from 'lucide-react';
import { useAtom } from 'jotai';
import { alertModal, auth_token, tab } from '../../atomstore/store';
import { useNavigate } from 'react-router-dom';
import { clearSavedTokenCache } from '../../queryfunctions/queryfunctions';

const More = () => {
    const navigate = useNavigate()
    const [, setActiveTab] = useAtom(tab)
    const [, setAuthToken] = useAtom(auth_token);
    const [modal, setModal] = useAtom(alertModal)


    const handleLogout = () => {
        // Clear auth state
        localStorage.removeItem('auth_token');
        setAuthToken('');
        // Clear saved token cache so saveToken can be called on next login
        clearSavedTokenCache();
        // Clear modal state on logout
        setModal({
            type: "",
            isConfirm: false,
            onOkPressed: () => { },
            onCancelPressed: () => { },
            message: "",
            state: false,
            navigateTo: null
        });
        navigate('/login')
        setActiveTab('home');

    };


    const moreOptions = [
        { icon: User, title: 'My Profile', desc: 'View and edit your account', screen: 'profile', gradient: 'from-orange-400 to-pink-500' },
        { icon: MessageCircle, title: 'Chat with Center', desc: 'Message your teacher directly', screen: 'chat', gradient: 'from-cyan-400 to-blue-500' },
        { icon: School, title: 'My School', desc: 'Center details & staff info', screen: 'my-school', gradient: 'from-purple-400 to-indigo-500' },
        { icon: PencilRuler, title: 'Growth Tracker', desc: 'Track developmental milestones', screen: 'growth', gradient: 'from-green-400 to-emerald-500' },
        { icon: Camera, title: 'Photo Gallery', desc: 'View all photos', screen: 'gallery', gradient: 'from-pink-400 to-rose-500' },
        { icon: Video, title: 'Parent Orientation Videos', desc: 'Educational resources', screen: 'videos', gradient: 'from-indigo-400 to-purple-500' },
        { icon: Newspaper, title: 'Newsroom', desc: 'Get the latest news info', screen: 'newsroom', gradient: 'from-green-400 to-emerald-500' },
        { icon: Activity, title: 'Outdoor Activity', desc: 'View activity request and status', screen: 'outdoor-activity', gradient: 'from-cyan-400 to-blue-500' }
    ];

    return (
        <div className="p-4 space-y-3">
            <h2 className="text-xl font-bold text-gray-800 mb-4">More</h2>

            {moreOptions.map((item, idx) => (
                <button
                    key={idx}
                    onClick={() => navigate('/' + item.screen)}
                    className="w-full bg-white rounded-2xl p-4 shadow-sm border border-gray-100 active:scale-95 transition"
                >
                    <div className="flex items-center space-x-3">
                        <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br ${item.gradient}`}>
                            <item.icon className="w-6 h-6 text-white" />
                        </div>
                        <div className="flex-1 text-left">
                            <p className="font-semibold text-gray-800">{item.title}</p>
                            <p className="text-sm text-gray-500">{item.desc}</p>
                        </div>
                        <ChevronRight className="w-5 h-5 text-gray-400" />
                    </div>
                </button>
            ))}

            <button
                onClick={() => setModal({
                    ...modal,
                    state: true,
                    type: "Success",
                    isConfirm: true,
                    message: "Are you sure you want to logout ?",
                    onOkPressed: async () => { handleLogout() },
                    onCancelPressed: () => { },
                })}
                className="w-full bg-white rounded-2xl p-4 shadow-sm border border-gray-100 active:scale-95 transition"
            >
                <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-red-400 to-rose-500">
                        <LogOut className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1 text-left">
                        <p className="font-semibold text-gray-800">Logout</p>
                        <p className="text-sm text-gray-500">Sign out of your account</p>
                    </div>
                </div>
            </button>
        </div>
    );
};

export default More;